import { useTranslation } from 'react-i18next';
import Container from '../../common/components/Container/Container';
import TitleContainer from '../../common/components/TitleContainer/TitleContainer';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Button, { ButtonStyle } from '../../common/components/Button/Button';
import SVGCopy from '../../common/assets/svg/icons/SVGCopy';
import { useState } from 'react';
import SVGBack from '../../common/assets/svg/icons/SVGBack';
import { useNavigate } from 'react-router-dom';

import QRCode from 'qrcode.react';
import withRouteAnalytics from '../../services/analytics/withRouteAnalytics';
import { Screens } from '../../services/analytics/screens';

// For continuing flow on a mobile device
function QRCodeScreen(): JSX.Element {
  const { t } = useTranslation();
  const currentUrl = window.location.href;
  const [linkCopied, setLinkCopied] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  return (
    <Container>
      <div className="items-left w-full">
        <Button
          style={ButtonStyle.INVERTED}
          onClick={handleBackButtonClick}
          disabled={false}
          extraClasses="flex-grow back-button"
          dataTestid="BACK_BUTTON"
        >
          <div className="flex text-textTertiary uppercase text-xs flex-grow items-center">
            <SVGBack />
          </div>
        </Button>
      </div>
      <TitleContainer center>
        <h1 data-testid="CONTINUE_WITH_LINK">{t('screens.documentPass.continueWithLink.title')}</h1>
        <div className="text-xl leading-6 mt-4 text-textParagraph" data-testid="CONTINUE_WITH_LINK_DESCRIPTION">
          <p>{t('screens.documentPass.continueWithLink.revocationDescription')}</p>
        </div>
      </TitleContainer>
      <QRCode
        data-testid="CONTINUE_WITH_LINK_QR_CODE"
        className="my-4 rounded-lg border-8 border-border"
        value={currentUrl}
        fgColor="#7C75FF"
        size={148}
      />
      <div className="text-xl leading-6 mb-4 text-textParagraph">
        <p>{t('screens.documentPass.continueWithLink.or')}</p>
      </div>
      <div className="full-width-ruler" />
      <CopyToClipboard text={currentUrl || ''} onCopy={() => setLinkCopied(true)}>
        <Button
          style={ButtonStyle.WIDE_SELECTOR}
          onClick={() => {}} /* click is handled by parent CopyToClipboard element */
          disabled={false}
          dataTestid="CONTINUE_WITH_LINK_COPY_LINK"
        >
          <div className="py-4 px-8 grid grid-cols-5 w-full items-center justify-left">
            <span className="col-span-4 text-left">{t('screens.documentPass.continueWithLink.copyLink')}</span>
            <div>
              <span className="float-right">
                <SVGCopy />
              </span>
            </div>
          </div>
        </Button>
      </CopyToClipboard>

      <div className="full-width-ruler mb-4" />
      <>
        {linkCopied && (
          <div
            className="text-lg leading-6 text-textParagraph flex justify-center w-full"
            data-testid="LINK_COPIED_MESSAGE"
          >
            {t('screens.documentPass.continueWithLink.linkCopied')}
          </div>
        )}
      </>
    </Container>
  );
}
export default withRouteAnalytics(QRCodeScreen, Screens.REVOCATION_QR_CODE);
